"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Settings_1 = __importDefault(require("configs/Settings"));
const baseSchema_1 = require("./baseSchema");
const constants_1 = require("./constants");
const event_agent_js_1 = __importDefault(require("@hotmart/event-agent-js"));
const isProd = process.env.NODE_ENV === 'production';
event_agent_js_1.default.mode = Settings_1.default.isProduction() ? 'production' : 'staging';
class DatahubEventsService {
    static sendEvent({ schema, dataVersion = constants_1.DATA_VERSION, eventVersion = constants_1.EVENT_VERSION, system = baseSchema_1.Systems.HOTMART_CLUB, clubVersion }) {
        const dataHubEvent = {
            system,
            action: schema.action,
            entity: baseSchema_1.DataHubEntities.ADMIN,
            data_version: dataVersion,
            event_version: eventVersion,
            event: {
                ...schema.getDataHubEventData(),
                ...(clubVersion ? { clubVersion } : {})
            }
        };
        if (!isProd) {
            console.log('Datahub event dispatched: ', dataHubEvent);
        }
        event_agent_js_1.default.send(dataHubEvent);
    }
}
exports.default = DatahubEventsService;
